import Link from '@mui/material/Link'
import React from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup'
import MediaQuery from 'react-responsive'
import Radio from '@mui/material/Radio'
import Button from '@mui/material/Button'
import { ConversionDialog } from '../conversionDialog'
import { ConversionPaywallDialog } from '../conversionPaywallDialog'
import { NumberFormatCustom } from '../numberFormatCustom'
import PlanImage from '../../images/plan.svg'
import * as S from './styles'
import { buildPayload } from '../RDIntegration'

const PlanSchema = Yup.object().shape({
	monthlyIncome: Yup.string()
	.required('Preencha este campo.'),
	savedMoney: Yup.string()
	.required('Preencha este campo.'),
	monthlySave: Yup.string()
	.required('Preencha este campo.'),
	retirement: Yup.string()
	.required('Preencha este campo.'),

	INSSmonthlyRetirement: Yup.string()
	.when('retirement', {
		is: (retirement) => retirement === 'INSS',
		then: Yup.string()
		.required('Preencha este campo.'),
	}),
	INSSage: Yup.string()
	.when('retirement', {
		is: (retirement) => retirement === 'INSS',
		then: Yup.string()
		.required('Preencha este campo.'),
	}),
	desiredRetirement: Yup.string()
	.required('Preencha este campo.'),
})

const isButtonDisabled = (values) => {
	const hasRetirement = values.retirement === 'INSS'
	const defaultFields = ['monthlyIncome', 'savedMoney', 'monthlySave', 'desiredRetirement'].some((k) => !values[k])
	const inssFields = hasRetirement ? !values.INSSmonthlyRetirement || !values.INSSage : false

	return hasRetirement ? defaultFields || inssFields : defaultFields
}

export function Plan({ data, setData, setStepState, stepState }) {
	const [open, setOpen] = React.useState(false)
	const [paywallOpen, setPaywallOpen] = React.useState(false)

	const handleClickOpenDialog = () => {
		setOpen(true)
	}

	const handleCloseDialog = () => {
		setOpen(false)
	}

	const handleClickOpenPaywallDialog = () => {
		setPaywallOpen(true)
	}

	const handleClosePaywallDialog = () => {
		setPaywallOpen(false)
	}

	return (<Formik
	validateOnBlur={false}
	validateOnChange={false}
	initialValues={data}
	validationSchema={PlanSchema}
	onSubmit={(values) => {
		setData({ ...data, ...values })
		handleClickOpenPaywallDialog()
	}}
	>
		{({ values, errors, handleChange, handleSubmit, dirty }) => (<>
			<S.Container style={{
				justifyContent: 'center',
			}}>
				<S.Form>
					<S.Text>Quais são suas estimativas de receita e despesa?</S.Text>
					<S.Input
					fullWidth variant="filled"
					id="monthlyIncome" name="monthlyIncome"
					onChange={handleChange}
					label="Qual sua renda mensal?" value={values.monthlyIncome}
					error={!!errors.monthlyIncome} helperText={errors.monthlyIncome || ' '}
					InputProps={{
						inputComponent: NumberFormatCustom,
					}}/>
					<S.Input
					fullWidth variant="filled"
					id="savedMoney" name="savedMoney"
					onChange={handleChange}
					value={values.savedMoney} label="Quanto você já tem guardado?"
					error={!!errors.savedMoney} helperText={errors.savedMoney || ' '}
					InputProps={{
						inputComponent: NumberFormatCustom,
					}}/>
					<S.Input
					fullWidth variant="filled"
					id="monthlySave" name="monthlySave"
					onChange={handleChange}
					value={values.monthlySave} label="Quanto você planeja guardar por mês?"
					error={!!errors.monthlySave} helperText={errors.monthlySave || ' '}
					InputProps={{
						inputComponent: NumberFormatCustom,
					}}/>

					<S.Text>Vai receber alguma aposentadoria? (<Link style={{ cursor: 'pointer' }} onClick={handleClickOpenDialog}>INSS</Link>, Pensão, Aluguel)</S.Text>
					<S.Control>
						<Radio
						name="retirement"
						id="retirement-1"
						checked={values.retirement === 'INSS'}
						onChange={handleChange}
						value="INSS"
						inputProps={{ 'aria-label': 'INSS' }}
						color="primary"
						/>
						<S.Label firstChild={true} htmlFor="retirement-1">SIM</S.Label>
						<Radio
						name="retirement"
						id="retirement-2"
						checked={values.retirement === 'Não'}
						onChange={handleChange}
						value="Não"
						inputProps={{ 'aria-label': 'Não' }}
						color="primary"
						/>
						<S.Label htmlFor="retirement-2">Não</S.Label>
					</S.Control>
					<S.Control type="input">
						<S.Input
						disabled={values.retirement === 'Não'}
						firstChild={true}
						fullWidth variant="filled"
						id="INSSmonthlyRetirement" name="INSSmonthlyRetirement"
						onChange={handleChange}
						value={values.INSSmonthlyRetirement} label="Quanto vai receber por mês?"
						error={!!errors.INSSmonthlyRetirement} helperText={errors.INSSmonthlyRetirement || ' '}
						InputProps={{
							inputComponent: NumberFormatCustom,
						}}/>
						<S.Input
						disabled={values.retirement === 'Não'}
						lastChild={true}
						fullWidth variant="filled"
						id="INSSage" name="INSSage" type="number"
						onChange={handleChange}
						InputProps={{
							inputProps: {
								min: 0,
								max: 100
							}
						}}
						value={values.INSSage} label="Com que idade começa?"
						error={!!errors.INSSage} helperText={errors.INSSage || ' '}/>
					</S.Control>
					<S.Hr/>
					<S.Input
					fullWidth variant="filled"
					id="desiredRetirement" name="desiredRetirement"
					onChange={handleChange}
					value={values.desiredRetirement} label="Qual renda deseja na independência financeira?"
					error={!!errors.desiredRetirement} helperText={errors.desiredRetirement || ' '}
					InputProps={{
						inputComponent: NumberFormatCustom,
					}}/>
				</S.Form>
				<ConversionDialog open={open} initialStep={1} handleCloseDialog={handleCloseDialog} data={data}/>
				<ConversionPaywallDialog setState={setStepState} state={stepState} open={paywallOpen} initialStep={1} handleCloseDialog={handleClosePaywallDialog} data={data}/>
				{/* <MediaQuery query="(min-width: 1024px)">
					<S.BoxImage>
						<S.Image src={PlanImage} alt="Plano de independência financeira" title="Plano de independência financeira"/>
					</S.BoxImage>
				</MediaQuery> */}
			</S.Container>
			<S.Footer style={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
			}}>
				<S.Hr style={{
					width: '100%',
				}}/>
				<S.Container>
					<Button onClick={() => {
						window.mixpanel.track("Back to step 1 button")
						setStepState({
							...stepState,
							index: 0
						})
					}} className="btn-plan button-back" variant="contained" color="secondary">PASSO ANTERIOR</Button>
					<Button onClick={handleSubmit} disabled={isButtonDisabled(values)} className="btn-plan" variant="contained" color="primary">PRÓXIMO PASSO</Button>
				</S.Container>
			</S.Footer>
		</>)}
	</Formik>)
}
